import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ActiveTeamActionType, ActiveTeamElement, ActiveTeamStore } from './ActiveTeamReducer.types';

// @ts-ignore
export const initialState: ActiveTeamStore = Immutable.fromJS({
  activeTeam: null,
  totalAlphasSubmitted: null,
  teamScore: null,
  teamRank: null,
  numberOfActiveMembers: null,
});

const updateTeamData = (state: ActiveTeamStore, action: ActiveTeamActionType) => {
  if (action.payload.status === 'ACCEPTED') {
    const activeTeam = action.payload.data.results.filter((team: ActiveTeamElement) => team.status === 'ACTIVE')[0];
    const userId = action.payload.userId;
    if (activeTeam) {
      const newActiveTeam = {
        name: activeTeam.name,
        id: activeTeam.id,
        university: activeTeam.university,
        status: activeTeam.status,
        country: activeTeam.country,
        dateCreated: activeTeam.dateCreated,
        members: activeTeam.members,
        type: activeTeam.type,
      };
      if (activeTeam.members) {
        const members = activeTeam.members.sort(
          (a: any, b: any) => (a.user.id === userId ? -1 : b.user.id === userId ? 1 : 0) || a.status.localeCompare(b.status)
        );
        let totalAlphasSubmitted: number = 0;
        let numberOfActiveMembers = 0;
        members.map((member: any) => {
          if (member.activity) {
            const submissions: number = member.activity.submissions;
            totalAlphasSubmitted = totalAlphasSubmitted + submissions;
          }
          if (member.status === 'ACCEPTED') {
            numberOfActiveMembers = numberOfActiveMembers + 1;
          }
        });

        return state
          .set('activeTeam', Immutable.fromJS(newActiveTeam))
          .set('totalAlphasSubmitted', totalAlphasSubmitted)
          .set('numberOfActiveMembers', numberOfActiveMembers);
      }

      return state.set('activeTeam', Immutable.fromJS(newActiveTeam));
    } else {
      return initialState;
    }
  }

  return state;
};

const ActiveTeamReducer = handleActions<any>(
  {
    TEAM_UPDATE_REPONSE_SUCCESS: (state: ActiveTeamStore, action: ActiveTeamActionType) => updateTeamData(state, action),
    USER_TEAMS_RESPONSE: (state: ActiveTeamStore, action: ActiveTeamActionType) => updateTeamData(state, action),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default ActiveTeamReducer;
